// // src/pages/components/StatusBadge.tsx
// import React from 'react';

// interface StatusBadgeProps {
//   status: string;
// }

// function StatusBadge({ status }: StatusBadgeProps) {
//   const getStatusClass = (status: string) => {
//     switch (status) {
//       case 'TODO': return 'status-todo';
//       case 'IN_PROGRESS': return 'status-progress';
//       case 'IN_REVIEW': return 'status-review';
//       case 'BLOCKED': return 'status-blocked';
//       case 'DONE': return 'status-done';
//       case 'CANCELLED': return 'status-cancelled';
//       default: return 'status-default';
//     }
//   };

//   const getStatusLabel = (status: string) => {
//     switch (status) {
//       case 'TODO': return 'To Do';
//       case 'IN_PROGRESS': return 'In Progress';
//       case 'IN_REVIEW': return 'In Review';
//       default: return status;
//     }
//   };

//   return (
//     <span className={`status-badge ${getStatusClass(status)}`}>
//       {getStatusLabel(status)}
//     </span>
//   );
// }

// export default StatusBadge;

// src/pages/components/StatusBadge.tsx
import React from 'react';

interface StatusBadgeProps {
  status: string;
}

function StatusBadge({ status }: StatusBadgeProps) {
  const getStatusStyles = (status: string) => {
    switch (status) {
      case 'TODO':
        return 'bg-gray-100 text-gray-700 border-gray-200';
      case 'IN_PROGRESS':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'IN_REVIEW':
        return 'bg-purple-100 text-purple-700 border-purple-200';
      case 'BLOCKED':
        return 'bg-red-100 text-red-700 border-red-200';
      case 'DONE':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'CANCELLED':
        return 'bg-gray-100 text-gray-500 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'TODO': return 'To Do';
      case 'IN_PROGRESS': return 'In Progress';
      case 'IN_REVIEW': return 'In Review';
      default: return status;
    }
  };

  return (
    <span className={`px-2 py-1 rounded-lg text-xs font-medium border ${getStatusStyles(status)}`}>
      {getStatusLabel(status)}
    </span>
  );
}

export default StatusBadge;